import { getAPIHost } from '@rsos/base-utils/metaTags';

export const refreshAccessToken = async refreshToken => {
  try {
    const apiHost = getAPIHost();
    const response = await fetch(
      `${apiHost}/v1/scorpius/user/api-token-auth/refresh`,
      {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${refreshToken}`,
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ refresh_token: refreshToken }),
      },
    );

    if (!response.ok) {
      throw new Error('Failed to refresh access token');
    }

    const data = await response.json();
    return data.token;
  } catch (error) {
    throw error;
  }
};
